export default __webpack_public_path__ + "static/media/ExpandFilled.6e225efc.svg";